import { of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { type Auth0Service } from './core/oauth0';
import { type CurrentUserService, type GtmService, type TenantsService, type UsersService } from './core/services';

export function appInitializer(
  auth: Auth0Service,
  currentUser: CurrentUserService,
  usersService: UsersService,
  tenantService: TenantsService,
  gtmService: GtmService
) {
  /** Check tokens from cookies and login to firebase */
  return () =>
    auth.checkCookies().pipe(
      /** If no valid cookies, process auth0 authentication */
      switchMap(userId => (userId ? of(userId) : auth.checkSession())),
      /** Get current user from firebase */
      switchMap(userId => usersService.getUserByUserId(userId)),
      /** Store profile and load its language */
      switchMap(user => {
        if (!user) {
          throw new Error('User not found');
        }
        return currentUser.setProfile(user);
      }),
      /** Get current tenant from firebase */
      switchMap(() => tenantService.getCurrent()),
      /** Store tenant and initialize gtm */
      map(tenant => {
        if (!tenant) {
          throw new Error('Current tenant not found');
        }
        currentUser.setTenant(tenant);
        gtmService.initialize(currentUser.profile!, tenant);
      })
    );
}
